/** @jsx jsx */
import { css } from '@emotion/core';

export const scheduleItemTitleCss = css({
  display: 'inline-block',
  width: 140,
  marginRight: 32,
});
